import { cronHttp } from "api/cronHttp";
import { http } from "api/http";


const disableAtomProIncomeTaxTanClients = (data: any) => {
  return http.put("/tan-sync/disableIncomeTaxClient", data);
};

const disableIncomeTaxTanClient = (id: number) => {
  return http.put(`/tan-sync/disableIncomeTax/${id}`);
};

const enableIncomeTaxTanClient = (id) => {
  return http.put(`/tan-sync/enableIncomeTax/${id}`);
};

const enableBulkIncomeTaxTanClient = (data) => {
  return http.post(`/tan-sync/enableIncomeTax/bulk-enable`, data);
};

const getDeletedIncometaxTanClients = ({ queryKey }) => {
  let { limit, offset, search,sort, query } = queryKey[1] || {};
  return http.get("/tan-sync/deletedClients", {
    params: {
      limit,
      offset,
      search,
      sort,
      ...query,
    },
  });
};

const exportIncomeTaxTandeletedClients = (data: any) => {
  return cronHttp.post("/tan-sync/deletedIncomeTaxreport", data);
};

const disableAtomProIncomeTaxClients = (data: any) => {
  return http.put("/tan-sync/disableIncomeTaxClient", data);
};

 // BULK SYNC
 const bulkAutomationSync = (data: any) => {
  return http.post(`/tan-sync/bulkSync`, data);
};

//SCHEDULING SYNC
const organizationScheduling = () => {
  return http.get(`/tan-sync/scheduling`);
};

const checkNoOfSync = () => {
  return http.get(`/tan-sync/checkNoOfSync`);
};

const incomeTaxTanScheduling = (data: any) => {
  return http.post(`/tan-sync/scheduling`, data);
};

const getBulkSyncStatus = () => {
  return http.get("/tan-sync/bulkSyncStatus");
};

const updateEnableStatus = () => {
  return http.put(`/tan-sync/enableStatus`);
};

const updateDisableStatus = () => {
  return http.put(`/tan-sync/disableStatus`);
};

//Traces
const organizationTraceScheduling = () => {
  return http.get(`/tan-sync/scheduling-trace`);
};

const tracesScheduling = (data: any) => {
  return http.post(`/tan-sync/scheduling-trace`, data);
};

const getTracesBulkSyncStatus = () => {
  return http.get("/tan-sync/bulkSyncStatus-trace");
};

const updateTracesEnableStatus = () => {
  return http.put(`/tan-sync/enableStatus-trace`);
};

const updateTracesDisableStatus = () => {
  return http.put(`/tan-sync/disableStatus-trace`);
};

export {
  exportIncomeTaxTandeletedClients,
  disableAtomProIncomeTaxTanClients,
  disableIncomeTaxTanClient,
  enableIncomeTaxTanClient,
  getDeletedIncometaxTanClients,
  disableAtomProIncomeTaxClients,
  bulkAutomationSync,
  organizationScheduling,
  checkNoOfSync,
  incomeTaxTanScheduling,
  getBulkSyncStatus,
  updateEnableStatus,
  updateDisableStatus,
  getTracesBulkSyncStatus,
  updateTracesEnableStatus,
  updateTracesDisableStatus,
  tracesScheduling,
  organizationTraceScheduling,
  enableBulkIncomeTaxTanClient
};
